<template>
    <div>
        <section class="content-header">
            <h1>
                Publicación de vehículos
            </h1>
        </section>
        <section class="content">

            <div class="container-fluid">
                <!-- basic data vehicle box -->
                <div class="box box-default box-basic-data">
                    <!-- .box-body -->
                    <div class="box-body">
                        <search-cars-datatable></search-cars-datatable>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import SearchCarsDatatable from '../datatables/PublicationCarsDatatable'
export default {
  name: 'PagePublicationComponent',
  components: {SearchCarsDatatable}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/PagePublicationComponent.vue